/**
 * AuditoriaLogConforme
 * @author JoodyKonno
 */
export enum AuditoriaLogConforme {
  CONFORME = 'Conforme',
  NAO_CONFORME = 'Não Conforme',
}
